<template>
  <DialogTemplate>
    <div class="f-column">
      <div class="weight_700 text-semi-large d-flex">
        <div class="my-auto">
          {{ $t(`messages.nodelock_no_locked_hands`) }}
        </div>
      </div>
      <ul
        style="max-width: 24rem"
        class="pb-4 pt-1 text-normal clr-grey pl-4"
      >
        <li v-html="$t(`messages.nodelock_unlocked_hands_will_be`)"></li>
        <li v-html="$t(`messages.nodelock_locked_hands_will_be`)"></li>
      </ul>
    </div>
    <template #dialog_actions>
      <div class="d-flex w-100">
        <div
          class="gw_btn weight_500 ml-auto mr-2"
          @click="apply"
        >
          <div class="mdi mdi-lock-open-outline mr-1"></div>
          {{ $t('btn.continue') }}
        </div>
        <div
          class="gw_btn weight_500 gw_btn_primary"
          @click="lockAllAndApply"
        >
          <div class="mdi mdi-lock mr-1"></div>
          {{ $t('btn.lock_all_and_continue') }}
        </div>
      </div>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'PromptNodelockDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    lockAllAndApply() {
      this.$store.dispatch('globals_action', 'nodelock_lockallconfirmnodelock')
      this.close()
    },
    apply() {
      this.$store.dispatch('globals_action', 'nodelock_confirmnodelock')
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'prompt-nodelock-dialog')
    },
  },
}
</script>

<style lang="scss" scoped>
.rb-dialog_action {
  border-radius: 4px;
  text-shadow: var(--text-shadow_drop);
  min-width: 6rem;
}
</style>
